const fbId = process.env.NEXT_PUBLIC_FACEBOOK_APP_ID

export const useMessenger = () => {
  const redirectToMessenger = ({ url }: { url: string }) => {
    if (fbId) {
      const link = encodeURI(
        `https://www.facebook.com/dialog/send?link=${url}&app_id=${fbId}&redirect_uri=${url}`
      )

      const newWindow = window.open(link, '_blank')
      if (newWindow) {
        newWindow.opener = null
      }
    }
  }

  return { redirectToMessenger }
}
